import About from 'components/About/About'

export default About
